export default {
      id: "edit_camera-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "img/icons.svg#edit_camera",
      toString: function () {
        return this.url;
      }
    }